<script lang="ts">
import VSelect           from '@/lib/components/VSelect/VSelect.vue';
import VSelectChips           from '@/lib/components/VSelectChips/VSelectChips.vue';
import PersonsService       from '@/domains/Persons/PersonsService';

export default defineComponent({
	name: "SelectSemple",

	components: {
		VSelect,
		VSelectChips
	},

	data() {
		return {
			model1: null,
			options1: new Array(5).fill(null).map((v, i) => {
				return {
					name: "Option " + i,
					id: i,
					label: 'label ' + i
				};
			}),

			model2: null,
			options2: new Array(5).fill(null).map((v, i) => {
				return {
					name: "Option " + i,
					id: i,
					label: 'label ' + i
				}
			}),
			modelChips: [],
			PersonsService,
		}
	},
	methods:  {}
});
</script>

<template>
		<article>
			<h2>VSelect</h2>
			<VSelect
				v-model="model1"
				:options="options1"
				option-label="name"
				placeholder="Choose option..."
			/>
		</article>
		<article>
			<h2>VSelect Multiple</h2>
			<VSelect
				v-model="model2"
				:options="options2"
				option-label="name"
				multiple
				placeholder="Choose options..."
			/>
		</article>
		<article>
			<h2>VSelectChips</h2>
			<VSelectChips
				ref="responsible"
				v-model="modelChips"
				label="Ответственные"
				layout="vertical"
				:search-function="PersonsService.searchPersons"
			>
				<template #helper-text>
					Не забудьте сохранить карточку партнера после добавления или удаления ответственного
				</template>
			</VSelectChips>
		</article>
</template>
